// Import global stylesheets
require('./src/styles/globals.scss');
